import React from "react";
import ReactTable from "react-table";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

const {UniversalModal} = Framework.Elements;
import {Objects} from "components";

class AltruPayTerminals extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Terminals_Altrupay._name, API.RequestType.READ_ALL);
		super(props, model);
		this.fetchData();
	}

	render() {
		const {data, loading} = this.state;

		//TODO: puts cards here that they can edit each register, since we're gonna just take their information and dump it into the select on checkout... also the backend needs to check if theyre paying for enough terminals

		return (
			<div className={'form-group'}>
				<Button onClick={() => this.setState({modalAddTerminal: true})}
				        variant="contained"
				        color="primary"
				>
					Add Terminal
				</Button>
				<div className={'row'}>
					{data?.map((item) =>
						<div className={'col-6'}>
							<Objects.AltrupaySpinProcessor
								id={item.pkey}
								account={this.props.account}
								afterDelete={() => {
									//reload the tab
									this.props.history.push('/');
									this.props.history.push('/settings#altrupay');
								}}
							/>
						</div>
					)}
				</div>
				{APPCONFIG.settings.isDev() ? null :
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				}
				<Framework.Elements.UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					title={"New AltruPay Terminal"}
					//					submitLabel={"Add"}
					object={Objects.AltrupaySpinProcessor}
					history={this.props.history}
					toggle={this.state.modalAddTerminal}
					reportClose={() => {
						this.setState({modalAddTerminal: false})
					}}
					//					afterSave={() => window.location.reload()}
					size={'lg'}
					hideGoTo={true}
				/>
			</div>

		)
	}
}

export default Framework.Components.withRootState(AltruPayTerminals);
